__turbopack_context__.v({
  "body": "layout-module-scss-module__uQLIpG__body",
  "html": "layout-module-scss-module__uQLIpG__html",
});
